// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"7d785e3a","168":"b3dccede","353":"c603895e","631":"195b26e3","822":"40852634","939":"fb8f9bc0"}[chunkId] + ".chunk.js";
};